import { Box, Stack, Theme, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { useLocalStorage } from 'usehooks-ts';

import { Page } from '@/components/Layout/Page/Page';
import { OnboardingGuide } from '@/components/OnboardingGuide';

import { ERROR_CODE } from '@/constants/api';
import { LS_USER_BLOCKED_AT_PATH } from '@/constants/common';
import { ROUTE } from '@/constants/routes';

import { useTranslate } from '@/hooks/useTranslate';

import { getAPIErrorCode } from '@/utils/api';
import { PROGRESS_STEPS } from '@/utils/progressSteps';

import { AddAdultDetailForm } from '../components/ApplicationTypeSelection/AdultDetailForm';
import { AddAdultDetailFormType } from '../components/ApplicationTypeSelection/AdultDetailForm/helper';

export const AddAdultDetailComponent: React.FC = () => {
  const { t } = useTranslate();
  const navigate = useNavigate();
  const [_, setUserBlockedPath] = useLocalStorage(LS_USER_BLOCKED_AT_PATH, '');

  const handleSubmitSuccess = (data: AddAdultDetailFormType) => {
    navigate(ROUTE.ADD_ADULT_DETAIL_RESULT, {
      replace: true,
      state: { adultDetail: data },
    });
  };

  const handleSubmitError = (error: unknown) => {
    if (getAPIErrorCode(error) === ERROR_CODE.ADULT_UNDER_18) {
      navigate(ROUTE.ADD_ADULT_DETAIL_RESULT_FAILED, {
        replace: true,
      });
      setUserBlockedPath(ROUTE.ADD_ADULT_DETAIL_RESULT_FAILED);
    }
  };

  return (
    <Page
      paperProps={{
        color: (theme: Theme) => theme.palette.neutral[1000],
        position: 'right',
        size: 'big',
        children: <OnboardingGuide />,
      }}
      progressProps={PROGRESS_STEPS.thirdPartyComplianceCheckStep}
      hasLogo
    >
      <Stack direction="column" spacing={4}>
        <Typography variant="h3" textAlign="left" mb={1}>
          {t('page.addAdultDetail.title')}
        </Typography>
        <Box maxWidth={360} width="100%">
          <AddAdultDetailForm
            onSubmitted={handleSubmitSuccess}
            onSubmitError={handleSubmitError}
          />
        </Box>
      </Stack>
    </Page>
  );
};

export default function AddAdultDetailPage() {
  return <AddAdultDetailComponent />;
}
